export const toObject = (data, keyField) => (data
    ? data.reduce((obj, item) => {
        const object = obj;
        object[item[keyField]] = item;
        return object;
      }, {})
    : {});

export const isTrue = () => true;
